import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import './hourlyForecastHour.scss';

const HourlyForecastHour = (props) => {
  const {
    hourNum,
    iconCode,
    mode,
    precip,
    precipBarHeight,
    temp,
    tempBarHeight,
    time,
  } = props;

  const tempBarStyle = {
    height: `${(tempBarHeight)}%`,
  };

  const precipBarStyle = {
    height: `${(precipBarHeight)}%`,
  };

  let hours = new Date(Date.parse(time)).getHours();
  const ampm = 12 <= hours ? 'PM' : 'AM';
  hours %= 12;
  hours = hours || 12;

  const formattedTime = `${hours}${ampm}`;

  const tempEl = <span className="hour__temp">{temp}º</span>;

  const precipEl = (
    <div className="hour__precip">
      <span className="weather-page__screen-reader-text">
        Chance of precipitation
      </span>
      {precip}%
    </div>
  );

  return (
    <div className="hourlyForecast__hour" key={hourNum}>
      <div className={classNames(
        'hour__temp-precip',
        { precip: 'precip' === mode },
      )}
      >
        {'precip' === mode ? precipEl : tempEl}
        <span
          className={classNames(
            'hour__temp-precip-bar',
            { precip: 'precip' === mode },
          )}
          style={'precip' === mode ? precipBarStyle : tempBarStyle}
        />
      </div>
      <div className="hour__time">{formattedTime}</div>
      <i className={`hour__icon weather-icon--${iconCode}`} />
      {'precip' === mode ? tempEl : precipEl}
    </div>
  );
};

HourlyForecastHour.propTypes = {
  hourNum: PropTypes.string.isRequired,
  iconCode: PropTypes.string.isRequired,
  mode: PropTypes.oneOf(['temp', 'precip']).isRequired,
  precip: PropTypes.string.isRequired,
  precipBarHeight: PropTypes.number.isRequired,
  temp: PropTypes.string.isRequired,
  tempBarHeight: PropTypes.number.isRequired,
  time: PropTypes.string.isRequired,
};

export default HourlyForecastHour;
